import { getAxisConfig } from "@hydrosoft/chart";
import { ElementLoader } from "./ElementLoader";
import { Utils } from "@hydrosoft/map-api";
export class ElementAxisLoader extends ElementLoader {
    getConfig() {
        return getAxisConfig(Utils.childrenToString(this._element.children), Utils.getAttributes(this._element.attribs));
    }
}
//# sourceMappingURL=ElementAxisLoader.js.map